import { AxiosResponse } from 'axios';
import { UseQueryResult, useQuery } from 'react-query';
import { AvgPackageUtilizationRate } from 'types';
import { client } from 'utils/api-client';

function usePackageUtilizationAvgRate(): UseQueryResult<AxiosResponse<AvgPackageUtilizationRate>> {
  return useQuery({
    queryKey: ['package-utilization-avg-rate'],
    queryFn: () => client.get('/reports/utilization/package-utilization/avg-rate'),
  });
}

export default usePackageUtilizationAvgRate;
